import { render, staticRenderFns } from "./AttachmentUploader.vue?vue&type=template&id=4f794fe6"
import script from "./AttachmentUploader.vue?vue&type=script&lang=ts"
export * from "./AttachmentUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports